import { CHANGE_MAPSCALE_SCALE, TOGGLE_OPTIONAL_MAPSCALE } from './constants';
import { createReducer, baseReduceHandler } from '../reducer';
export const reducer = createReducer({}, {
    [CHANGE_MAPSCALE_SCALE]: baseReduceHandler,
    [TOGGLE_OPTIONAL_MAPSCALE]: baseReduceHandler,
});
//# sourceMappingURL=reducer.js.map